import qs from 'qs'

import { getAppOwnerId } from 'src/core/classes/helpers/getAppId'
import { proxyIdentity } from 'src/core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'src/core/classes/http'

export async function getMBETokenByOneTimeToken(oneTimeToken: string): Promise<{
  ClientId: string
  ClientSecret: string
  AccessToken: string
  RefreshToken: string
}> {
  const url = proxyIdentity('/mbe/api/v2/access/token')

  const clientId = oneTimeToken.substr(0, 32)
  const secretId = oneTimeToken.substr(32, oneTimeToken.length)

  if (!clientId || !secretId) {
    throw new Error('ClientId or SecretId is empty')
  }

  const headers = new HttpHeaders()
  headers.add('Content-Type', 'application/json')

  const payload = { ClientId: clientId, ClientSecret: secretId }

  return { ...payload, ...(await Rest.post({ url, payload, headers })) }
}

export async function authByOneTimeToken() {
  const queryObject = qs.parse(window.location.search.replace('?', ''))
  if (!queryObject.oneTime) {
    return
  }
  const credentials = await getMBETokenByOneTimeToken(queryObject.oneTime.toString())
  localStorage.setItem(`_hp_mbe_${getAppOwnerId()}_access_token`, credentials.AccessToken)
  localStorage.setItem(`_hp_mbe_${getAppOwnerId()}_refresh_token`, credentials.RefreshToken)
  localStorage.setItem(`_hp_mbe_${getAppOwnerId()}_client_id`, credentials.ClientId)
  localStorage.setItem(`_hp_mbe_${getAppOwnerId()}_secret_id`, credentials.ClientSecret)
}
